export default function BallotChart({ stats }) {
  const votedCount = stats?.flowsCompleted || 0
  const totalAudience = stats?.ballotAudience || 0
  const votedPercentage = totalAudience > 0 ? (votedCount / totalAudience) * 100 : 0

  return (
    <div style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        width: '120px',
        height: '300px',
        background: 'rgba(24, 24, 91, 0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column-reverse',
        position: 'relative'
      }}>
        <div style={{
          height: `${votedPercentage}%`,
          background: '#00F399',
          transition: 'height 0.3s ease'
        }}></div>
      </div>
      <p style={{
        marginTop: '20px',
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#18185b'
      }}>
        {votedCount}/{totalAudience} voted
      </p>
    </div>
  )
}
